import { Component, Input, OnInit } from '@angular/core';

@Component({
	selector: 'app-dashboard-box',
	templateUrl: './dashboard-box.component.html',
	styleUrls: ['./dashboard-box.component.scss']
})
export class DashboardBoxComponent {
	@Input() borderColorId: number;
	@Input() value: number;
	@Input() units: string;
	@Input() title: string;
	@Input() subtitle: string;

	constructor() {}
}
